import { BRANDING } from './branding.jsx';

/** @type {typeof BRANDING & { primaryColor?: string }} */
export const MOCK_BRANDING = {
  ...BRANDING,
  primaryColor: undefined,
};
